import { YEAR_MS } from '@dr.pogodin/js-utils';
import type { UseAsyncDataResT } from '@dr.pogodin/react-utils';

import { getProfileHeroImage } from 'services';

import { type ImageAssetT, useAsyncCollection } from 'utils';

type UseProfileHeroImageResT = UseAsyncDataResT<ImageAssetT>;

export function useProfileHeroImage(artistId: string): UseProfileHeroImageResT {
  return useAsyncCollection(
    artistId,
    'artistProfileHeroImages',
    async (id) => (id ? getProfileHeroImage(id) : Promise.resolve(null)),
    { maxage: YEAR_MS },
  );
}
